// import React, { useState } from "react";
// import { BrowserRouter, Routes, Route } from "react-router-dom";
// import Navbar from "./components/Navbar";
// import Footer from "./components/Footer";
// import Hero from "./components/Hero";
// import Services from "./components/Services";
// import InformationSection from "./components/InformationSection";
// import WhatWeOffer from "./components/WhatWeOffer";
// import CaptureSection from "./components/CaptureSection";
// import PartnerSection from "./components/PartnerSection";
// import ContactForm from "./components/ContactForm";
// import WhoWeAre from "./components/WhoWeAre";
// import AugmentedReality from "./Pages/AugmentedReality";
// import StartFree from "./Pages/StartFree";
// import SearchBar from "./Pages/SearchBar";
// import MenuBar from "./Pages/MenuBar";
// import ChatBot from "react-simple-chatbot";
// import "./global.css";

// const Layout = ({ children }) => (
//   <>
//     <Navbar />
//     {children}
//     <Footer />
//     <ChatBot
//       steps={[
//         { id: "1", message: "What is your name?", trigger: "2" },
//         { id: "2", user: true, trigger: "3" },
//         { id: "3", message: "What is your email address?", trigger: "4" },
//         { id: "4", user: true, trigger: "5" },
//         { id: "5", message: "What is your contact number?", trigger: "6" },
//         { id: "6", user: true, trigger: "7" },
//         { id: "7", message: "How can I help you today?", trigger: "8" },
//         { id: "8", user: true, trigger: "9" },
//         { id: "9", message: "Thank you! Our team will get back to you soon.", end: true },
//       ]}
//       floating
//       floatingStyle={{
//         width: "50px",
//         height: "50px",
//         right: "20px",
//         bottom: "20px",
//         backgroundColor: "#007bff",
//       }}
//       style={{
//         maxWidth: "400px",
//         width: "300px",
//         height: "400px",
//         backgroundColor: "#007bff",
//         overflow: "hidden",
//         display: "flex",
//         flexDirection: "column",
//       }}
//     />
//   </>
// );

// const Home = ({ setHeroCount, heroCount }) => (
//   <Layout>
//     <Hero heroCount={heroCount} setHeroCount={setHeroCount} />
//     <WhoWeAre />
//     <Services />
//     <InformationSection />
//     <WhatWeOffer />
//     <CaptureSection />
//     <ContactForm />
//     <PartnerSection />
//   </Layout>
// );

// const App = () => {
//   const [heroCount, setHeroCount] = useState(2);

//   return (
//     <BrowserRouter>
//       <Routes>
//         <Route path="/" element={<Home setHeroCount={setHeroCount} heroCount={heroCount} />} />
//         <Route path="/start-free" element={<Layout><StartFree /></Layout>} />
//         <Route path="/search-bar" element={<Layout><SearchBar /></Layout>} />
//         <Route path="/menu-bar" element={<Layout><MenuBar /></Layout>} />
//         <Route path="/augmented-reality" element={<Layout><AugmentedReality /></Layout>} />
//       </Routes>
//     </BrowserRouter>
//   );
// };

// export default App;
// App.js



// App.js

import React, { useEffect } from 'react';
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import Navbar from './components/Navbar';
import './index.css';
import Page3 from './components/Page3';
import Virtualwalkthrough from './Pages/Virtualwalkthrough';
import CarouselPage from './components/CarouselPage';
import Page5 from './components/Page5';
import Page6 from './components/Page6';
import Footer from './components/Footer';
import ResearchandDevelopment from './Pages/ResearchandDevelopment';
import Dhapra from './Pages/Dhapra';
import HeavyIndustries from './Pages/HeavyIndustries';
import AerospaceAndAutomobile from './Pages/AerospaceAndAutomobile';
import Healthcare from './Pages/Healthcare';
import Education from './Pages/Education';
import Training from './Pages/Training';
import Realtimecollaboration from './Pages/Realtimecollaboration';
import Monitoring from './Pages/Monitoring';
import XR from './Pages/XR';
import ReactGA from "react-ga4";  // Google Analytics library
import usePageTracking from './Pages/usePageTracking';
import Academiccollaborations from './Pages/Academiccollaborations';
import EducationAndSkilling from './Pages/EducationAndSkilling';
import Aec from './Pages/Aec';
import LearningAndInnovation from './Pages/LearningAndInnovation';
import HospitalityAndInnovation from './Pages/HospitalityAndInnovation';
import ForAcademia from './Pages/ForAcademia';
import XRinfrastructure from './Pages/XRinfrastructure';
import SpatialViewer from './Pages/SpatialViewer';
import QuoteRequestForm from './components/QuoteRequestForm';
import Grid from './components/Grid';
import Courses from './Pages/Courses';
import Newsletter from './Pages/Newsletter';
import Hackathon from './Pages/Hackathon';
import SpatialHub from './Pages/SpatialHub';
import SpatialCatalogue from './components/SpatialCatalogue';
import QuoteLayout from './components/QuoteLayout';
import BookDemoAnimation from './components/BookDemoAnimation';
import VirtualPresentation from './components/VirtualPresentation';
import SeamlessIntegration from './components/SeamlessIntegration';
import CatalogueMobileExperiences from './components/CatalogueMobileExperiences';
import CatalogueMobileHero from './components/CatalogueMobileHero';
import CatalogueMobileInfo from './components/CatalogueMobileInfo';
import CatalogueMobileWhy from './components/CatalogueMobileWhy';
import CatalogueMobileShowcase from './components/CatalogueMobileShowcase';
import CatalogueMobileContact from './components/CatalogueMobileContact';
// const TRACKING_ID = "G-YW25RQHYJ9";
// ReactGA.initialize(TRACKING_ID);

const App = () => {

  usePageTracking();
  const trackButtonClick = (category, action, label) => {
    ReactGA.event({
      category,
      action,
      label
    });
  };

  return (
    <>
      <Navbar trackButtonClick={trackButtonClick} />
      <Routes>
        {/* Main Route */}
        <Route
          path="/"
          element={<Navigate to="/company" replace />}
        />
        <Route
          path="/company"
          element={
            <>
              <CarouselPage />
              <Page3 />
              <Grid />
              {/* <Page1 /> */}
              {/* <Page4 /> */}
              <Page5 />
              <Page6 />
              {/* <ContactForm /> */}
              <QuoteRequestForm />
              <Footer />
            </>
          }
        />
        <Route path="/products/spatialcatalogue" element={<>
          <CatalogueMobileHero />
          <CatalogueMobileInfo />
          <CatalogueMobileExperiences />
          <CatalogueMobileWhy />
          <CatalogueMobileShowcase />
          <CatalogueMobileContact />
          {/* <SpatialCatalogue />
          <QuoteLayout />
          <BookDemoAnimation /> */}
          {/* <VirtualPresentation />
          <SeamlessIntegration /> */}
        </>} />
        {/* Other Routes */}
        <Route path="/ResearchAndInnovation/academiccollaborations" element={<Academiccollaborations />} />
        <Route path="/ResearchAndInnovation/CorporateR&DPrograms" element={<ResearchandDevelopment />} />

        {/* <Route path="/spatialtech/digitaltwin" element={<Digitaltwin />} /> */}
        <Route path="/products/dhapra" element={<Dhapra />} />
        <Route path="/products/spatialviewer" element={<SpatialViewer />} />
        <Route path="/sectors/aerospaceAndautomobile" element={<AerospaceAndAutomobile />} />
        <Route path="/sectors/heavyindustries" element={<HeavyIndustries />} />
        <Route path="/sectors/healthcare" element={<Healthcare />} />
        <Route path="/sectors/education&skilling" element={<EducationAndSkilling />} />
        <Route path="/sectors/education" element={<Education />} />
        <Route path="/sectors/aec" element={<Aec />} />
        <Route path="/sectors/learningandinnovation" element={<LearningAndInnovation />} />
        <Route path="/sectors/hospitalityandtourism" element={<HospitalityAndInnovation />} />
        <Route path="/services/industries" element={<XR />} />
        <Route path="/services/academia" element={<ForAcademia />} />
        <Route path="/services/xrinfrastructure" element={<XRinfrastructure />} />
        <Route path="/services/virtualwalkthrough" element={<Virtualwalkthrough />} />
        <Route path="/services/training" element={<Training />} />
        <Route path="/services/collaboration" element={<Realtimecollaboration />} />
        <Route path="/services/monitoring" element={<Monitoring />} />
        {/* <Route path="/school/courses" element={<Courses />} />
        <Route path="/school/newsletter" element={<Newsletter />} />
        <Route path="/school/Hackathon"  element={<Hackathon />} />  */}
        <Route path="/school/spatialhub" element={<SpatialHub />} />
        <Route path="/contact" element={<QuoteRequestForm />} />
      </Routes>
    </>
  );
};

export default App;
